import React, { useEffect, useRef } from 'react'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let submitTab = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let submitGlobal = useDataSubmit({
    context: 'global',
    viewPath: props.viewPath,
  })

  let patient_overlay_patient_id = useDataValue({
    context: 'global',
    path: 'patient_overlay_patient_id',
    viewPath: props.viewPath,
  })

  let is_appointment_overlay_open = useDataValue({
    context: 'tab',
    path: 'appointment_overlay.open',
    viewPath: props.viewPath,
  })

  let patientOverlayTransitioning = useRef(false)

  // close patient overlay
  useEffect(() => {
    if (is_appointment_overlay_open) {
      patientOverlayTransitioning.current = true

      submitGlobal({ type: 'patientOverlay/close' })

      setTimeout(() => {
        patientOverlayTransitioning.current = false
      }, 100)
    }
  }, [is_appointment_overlay_open]) // eslint-disable-line react-hooks/exhaustive-deps

  // close on patient overlay open
  useEffect(() => {
    if (patient_overlay_patient_id && !patientOverlayTransitioning.current) {
      submitTab({ type: 'appointmentOverlay/close' })
    }
  }, [patient_overlay_patient_id]) // eslint-disable-line react-hooks/exhaustive-deps

  return <View {...props} />
}
